import * as GlobalUtils from '../../utils'
import * as Constants from './constants'
import * as Types from './types'

export const asFormFields = (sys: Types.System): Types.FormFields => {
  return {
    id: sys.id,
    key: sys.key,
    list_name: sys.list_name,
    secret: sys.secret,
    system_id: sys.system_id,
    system_name: sys.name,
    token: sys.token,
  }
}

export const removeSystem = (availableSystems: Types.System[], payload: Types.FormFields): Types.System[] => {
  return availableSystems.filter((system) => system.id !== payload.system_id)
}

export const updateSystem = (existingSystems: Types.System[], options: any): Types.System[] => {
  let index = 0
  let updatedSystem = existingSystems.filter((system, i) => {
    if (system.id === Number(options.url.split('/')[3])) {
      index = i
    }
    return system.id === Number(options.url.split('/')[3])
  })[0]

  const otherSystems = existingSystems.filter((system, i) => i !== index)
  updatedSystem = {
    ...updatedSystem,
    ...options.payload,
  }
  return GlobalUtils.insert(otherSystems, index, updatedSystem)
}

interface Options {
  payload: {
    is_active: boolean,
  }
}

export const reverse = (options: Options): Options => {
  return {...options,
    payload: {
      is_active: !options.payload.is_active,
    },
  }
}

export const getTargetSubscriber = (systemName: string) => {
  if (systemName === Constants.HUBSPOT) {
    return 'contacts'
  } else {
    return 'Contact'
  }
}

export const getKeyLabel = (systemName: string) => {
  if ([Constants.HUBSPOT, Constants.MAILCHIMP].includes(systemName)) {
    return 'API Key'
  } else {
    return 'Username'
  }
}

export const getKeyPlaceHolder = (systemName: string) => {
  if ([Constants.HUBSPOT, Constants.MAILCHIMP].includes(systemName)) {
    return 'Please enter your API Key'
  } else {
    return 'Please enter your Username'
  }
}



// WEBPACK FOOTER //
// ./src/pages/integrations/utils.ts